"use client";

import React from "react";

import Picture from "@/components/ui-kit/Picture/Picture";
import { TextElementNova } from "@/components/ui-kit/TextElementNova/TextElementNova";

import LearningProgress from "./LearningProgress";

const BADGE_IMAGE =
  "https://images.ctfassets.net/0rbfqd9c4jdo/3gYqOdUpTnXCHb66ypx5Hf/ab69e7ab2bc5dc0c806baab958c757e6/learning-complete-badge-new.png";

const LearningComplete = () => {
  return (
    <div className="flex flex-col lg:flex-row h-full items-center justify-center md:justify-between lg:justify-center gap-6 lg:gap-0">
      <div className="lg:flex-1 flex flex-col items-center md:mt-20 lg:mt-0">
        <div className="mb-6 lg:mb-10 w-[200px] lg:w-[250px]">
          <Picture
            src={BADGE_IMAGE}
            alt="Nutrafol Academy Hair Certified"
            className="block w-full"
          />
        </div>
        <div>
          <LearningProgress isSidebar={false} />
        </div>
      </div>
      <div className="md:mb-20 lg:mb-0 lg:flex-1">
        <div className="max-w-[336px] lg:max-w-none">
          <TextElementNova
            text="You’re officially #NutrafolAccredited!"
            className="Title-20-Super-Normal text-nova-base-white text-center mb-4 lg:mb-10"
          />
          <TextElementNova
            text="Your commitment helps build a more informed, empowered community."
            className="Subtitle-10-Dia-Normal text-nova-base-white text-center"
          />
        </div>
      </div>
    </div>
  );
};

export default LearningComplete;
